const Menu = {
  items: [
    {
      title: 'Home',
      icon: 'home',
      navigation: 'dashboard',
    },
    {
      title: 'Map',
      icon: 'map',
      navigation: 'map',
    },
    {
      title: 'Locations',
      icon: 'info',
      navigation: 'locations',
    },
    {
      title: 'Terms & Conditions',
      icon: 'insert_drive_file',
      navigation: 'ts-and-cs',
    },
    {
      title: 'Announcements',
      icon: 'alarm',
      navigation: 'announcements',
    },
  ],
};

export default Menu;
